import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

export const getDatabaseKindOfWineFiltersCollection = (
  _role: Role
): FiltersCollection =>
  pickEntries([
    databaseFiltersName.countryFilter2,
    databaseFiltersName.nationalGITypeFilter,
    databaseFiltersName.geoIndicationFilter,
    databaseFiltersName.wineTypeFilter,
    databaseFiltersName.wineColourFilter,
    databaseFiltersName.sweetnessTypeFilter,
  ])

export const databaseKindOfWineFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseKindOfWineFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
